'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var getSymbolFromCurrency = require('currency-symbol-map');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var getSymbolFromCurrency__default = /*#__PURE__*/_interopDefaultLegacy(getSymbolFromCurrency);

var abbreviateNumber = function (currency) {
    if (currency > 1000000000) {
        return "".concat((currency / 1000000000).toString(), "B");
    }
    else if (currency > 1000000) {
        return "".concat((currency / 1000000).toString(), "M");
    }
    else if (currency > 100000) {
        return "".concat((currency / 1000).toString(), "K");
    }
    return currency.toString();
};
var getCurrencySymbol = function (_a) {
    var currency = _a.currency;
    return getSymbolFromCurrency__default["default"](currency);
};
var convertToCurrency = function (_a) {
    var _b = _a.amount, amount = _b === void 0 ? 0 : _b, _c = _a.currency, currency = _c === void 0 ? 'USD' : _c;
    return "".concat(getCurrencySymbol({ currency: currency })).concat(amount.toLocaleString(undefined, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    }));
};

exports.abbreviateNumber = abbreviateNumber;
exports.convertToCurrency = convertToCurrency;
exports.getCurrencySymbol = getCurrencySymbol;
